import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css'
import '../scss/app.scss';
import { Spinner } from 'reactstrap';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setSpinner } from '../redux/Global';

import Router from './Router';
import { hasBlocker } from '../helpers/navigation'

class App extends Component {
  constructor() {
    super();
  }

  componentDidMount() {
    window.addEventListener('beforeunload', (e) => {
      if (hasBlocker()) {
        // Cancel the event as stated by the standard.
        e.preventDefault();
        // Chrome requires returnValue to be set.
        e.returnValue = "are you sure";
        return "are you sure";
      }
    })
  }

  render() {
    return (
      <div>
        {/* {
          this.props.global.pageSpinner &&
          <div className='load'>
            <div className='load__icon-wrap'>
              <div className="cssload-loader">
                <div className="cssload-side"></div>
                <div className="cssload-side"></div>
                <div className="cssload-side"></div>
                <div className="cssload-side"></div>
                <div className="cssload-side"></div>
                <div className="cssload-side"></div>
                <div className="cssload-side"></div>
                <div className="cssload-side"></div>
              </div>
            </div>
          </div>
        } */}
        { // Nikita new spinner
          this.props.global.pageSpinner &&
          <div className='load'>
            <div className='load__icon-wrap'>
              <Spinner color="secondary" style={{ width: '3rem', height: '3rem' }} />
              <img className="load-logo" alt="logo" src={require('../img/rintagi-square.png')} />
            </div>
          </div>
        }
        <div>
          <Router />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  global: state.global,
});

// const mapDispatchToProps = (dispatch) =>(
//   bindActionCreators(Object.assign({},
//     { setSpinner: setSpinner },
//   ), dispatch)
// )

const mapDispatchToProps = (dispatch) => (
  bindActionCreators({}, dispatch)
)

export default withRouter(connect(
  mapStateToProps, mapDispatchToProps
)(App));



// WEBPACK FOOTER //
// ./src/app/App.js